import React from 'react';

import { Stack } from '@gogame/components';

export default ({ icon }) => {
  return (
    <Stack
      alignItems={'center'}
      justifyContent={'center'}
      flex={'1 1 auto'}
      width={'100%'}
      backgroundColor={(theme) => theme.palette.divider}
    >
      {icon}
    </Stack>
  );
};
